import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';

const PacingStatus = ({ value, size, type }) => {
  if (value === null || typeof value === 'undefined' || Number.isNaN(value)) return null;

  const getPacingInfo = (value, type) => {
    if (type === 'roi') {
      if (value > 1.05) {
        return {
          color: '#F2994A',
          icon: 'arrowUp',
        };
      }

      if (value >= 0.9 && value <= 1.05) {
        return {
          color: '#219653',
          icon: 'check',
        };
      }

      if (value < 0.9) {
        return {
          color: '#EB5757',
          icon: 'arrowDown',
        };
      }
    } else {
      if (value > 1.05) {
        return {
          color: '#219653',
          icon: 'arrowUp',
        };
      }

      if (value >= 0.9 && value <= 1.05) {
        return {
          color: '#219653',
          icon: 'check',
        };
      }

      if (value >= 0.75 && value < 0.9) {
        return {
          color: '#F2994A',
          icon: 'arrowDown',
        };
      }

      if (value < 0.75) {
        return {
          color: '#EB5757',
          icon: 'arrowDown',
        };
      }
    }

    return null;
  };

  const pacingInfo = getPacingInfo(value, type);

  return <Icon color={pacingInfo.color} iconName={pacingInfo.icon} size={size} />;
};

PacingStatus.propTypes = {
  value: PropTypes.number.isRequired,
  size: PropTypes.number,
};

PacingStatus.defaultProps = {
  size: 11,
};

export default PacingStatus;
